import apiClient from '@u/apiClient'
import CreateChiftInvoicingConnexionController from '@/wayfinder/actions/App/Http/Controllers/Partner/ChiftInvoicing/CreateChiftInvoicingConnexionController'
import DeleteChiftInvoicingConnexionController from '@/wayfinder/actions/App/Http/Controllers/Partner/ChiftInvoicing/DeleteChiftInvoicingConnexionController'
import DeleteCompanyConnexionController from '@/wayfinder/actions/App/Http/Controllers/Chift/DeleteCompanyConnexionController'

export default {
  createChiftInvoicingConnexion(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateChiftInvoicingConnexionController.post({ company: payload.id }),
          {
            callback_url: payload.callback_url
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  disconnectChiftInvoicing(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteChiftInvoicingConnexionController.delete({
            company: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteChiftInvoicingConnexion(_, payload) {
    return Promise.all([
      apiClient.route(
        DeleteCompanyConnexionController.delete({
          company: payload.id,
          connexion_id: payload.connexion_id
        })
      ),
      apiClient.route(
        DeleteChiftInvoicingConnexionController.delete({ company: payload.id })
      )
    ])
  }
}
